import { render, staticRenderFns } from "./PatientLayout.vue?vue&type=template&id=16a55ffe&scoped=true"
import script from "./PatientLayout.vue?vue&type=script&lang=js"
export * from "./PatientLayout.vue?vue&type=script&lang=js"
import style0 from "./PatientLayout.vue?vue&type=style&index=0&id=16a55ffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a55ffe",
  null
  
)

export default component.exports